export const RESET_PASSWORD_SUCCESS = 'forgotpassword/RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'forgotpassword/RESET_PASSWORD_ERROR'
export const RESET_PASSWORD = 'forgotpassword/RESET_PASSWORD'
export const RESET = 'forgotPassword/RESET'
